/**
 * Visibility status helpers.
 *
 * Canonical public status is 'public' for all visibility entities
 * (places, producers, experiences, events).
 *
 * 'published' is reserved for legal_documents (different domain).
 */

/** Returns true if the place status represents a publicly visible place */
export function isPlacePublic(status: string | null | undefined): boolean {
  return status === 'public';
}

/** Returns true if the producer status represents a publicly visible producer */
export function isProducerPublic(status: string | null | undefined): boolean {
  return status === 'public';
}

/* ── Experience status ── */

export type ExperienceStatus = 'draft' | 'public' | 'archived';

export const EXPERIENCE_STATUS_OPTIONS: { value: ExperienceStatus; label: string }[] = [
  { value: 'draft', label: 'Utkast' },
  { value: 'public', label: 'Publicerad' },
  { value: 'archived', label: 'Arkiverad' },
];
